import { createContext, useContext, useRef } from "react";

const ScrollControlContext = createContext();

export const ScrollControlProvider = ({ children }) => {
  const skipScrollEffect = useRef(false);

  return (
    <ScrollControlContext.Provider value={{ skipScrollEffect }}>
      {children}
    </ScrollControlContext.Provider>
  );
};

export const useScrollControl = () => useContext(ScrollControlContext);